import React, {useState, useEffect} from 'react';

import {useChatStore} from '../../store/slices/chatStore';
import {useLogoutStore} from '../../store/slices/logoutStore';

const IconLogout = '/icons/logout.png';
import {ButtonWithIconAndWithTooltip} from '../../shared/components/ButtonWithIconAndWithTooltip/ButtonWithIconAndWithTooltip';

export const LogoutButton = () => {
  const messages = useChatStore((state) => state.messages);
  const responseFlow = useChatStore((state) => state.responseFlow);
  const responseType = useChatStore((state) => state.responseType);
  const actionLogout = useLogoutStore((state) => state.actionLogout);
  const [disabledButtonLogout, setDisabledButtonLogout] = useState('');

  const logoutChatbot = () => {
    useLogoutStore.getState().setGoLogout(!actionLogout);
    useLogoutStore.getState().continueChat(messages[messages.length - 1]);
    useLogoutStore.getState().continueType(responseType);
    useLogoutStore.getState().continueFlow(responseFlow);

    let messagesLogout = [
      {
        text: 'Sair do Credenciamento',
        type: 'response-sent'
      },
      {
        text: 'Você tem certeza de que deseja sair? Lembre-se de que todas as informações inseridas até agora serão perdidas, mas você sempre pode retornar quando quiser!',
        type: 'message-cancel-question'
      }
    ];

    useChatStore.getState().setMessages(messagesLogout);
    useChatStore.getState().responseTypeChange('disabled');
  };

  useEffect(() => {
    if (actionLogout) {
      return setDisabledButtonLogout('disabled');
    }

    return setDisabledButtonLogout('');
  }, [actionLogout]);

  return (
    <ButtonWithIconAndWithTooltip
      showButton={true}
      IconButton={IconLogout}
      actionButton={logoutChatbot}
      textTooltip="Sair do Credenciamento"
      textImageAlt="Ícone para sair do chatbot"
      disabledButton={disabledButtonLogout}
      htmlId="sair-credenciamento"
    />
  );
};
